import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'ui-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckboxComponent),
            multi: true,
        }],
    standalone: false
})
export class CheckboxComponent implements ControlValueAccessor {
  @Input('p-id') id: string;
  @Input('p-label') label: string;

  public checked: boolean = false;

  toggle() {
    this.checked = !this.checked;
    this.onChangeCallback(this.checked);
  }

  public onChangeCallback(value: any): void {
    this.writeValue(value);
  };
  
  public onTouchedCallback(value: any) {
    this.writeValue(value);
  };
  
  public writeValue(newValue: boolean) {
    this.checked = newValue;
  }

  public registerOnChange(onChangeCallback: any): void {
    this.onChangeCallback = onChangeCallback;
  }

  public registerOnTouched(onTouchedCallback: any): void {
    this.onTouchedCallback = onTouchedCallback;
  }
}
